/** Open positions create/edit. */
const dictionary = {
  "en": {
    "form": {
      "positionName": "Position name",
      "deadline": "Deadline",
      "department": "Department",
      "targetProfile": "Target profile",
      "targetProfileError": "Please select target profile",
      "positionTitleError": "Please enter position title",
      "targetProfileExplanation": "This tells what roles and career paths might be suitable for this person based on competence combinations. Remember that being successful in a role requires beside competencies also knowledge, skills and motivation.",
      "jobDescription": "Description",
      "visibleToCandidate": "Will be visible to candidates",
      "hiringProcess": "Hiring process"
    },
    "assessmentsInfo": "Please choose the assessments for the candidates.",
    "registeredCandidates": "Registered Candidates",
    "candidateList": "Candidate list",
    "inviteNewCandidate": "Invite new candidate",
    "viewPoolCandidates": "View Pool Candidates",
    "savePool": "Save Pool",
    "candidateCount": "{count} candidates",
    "deleteConfirmTitle": "Please confirm that you want to delete this pool {title}",
    "deleteConfirmCannotUndo": "This action cannot be undone.",
    "deleteConfirmData": "All data related to this pool will be permanently deleted.",
    "deleteConfirmTalentAccess": "However, candidates can still access their own data on Talent platform.",
    "toasts": {
      "updated": "Pool updated successfully",
      "updateError": "Unable to save changes. Please try again or contact support.",
      "networkError": "Network error. Please try again or contact support.",
      "deleted": "Pool deleted successfully",
      "deleteError": "Unable to delete pool. Please try again or contact support.",
      "deleteSystemError": "System error while deleting the pool. Please try again or contact support.",
      "deleteUnexpected": "An unexpected error occurred while deleting the pool. Please try again or contact support.",
      "inviteResent": "Invite resent.",
      "inviteResendError": "Unable to send invite, try again later"
    },
    "closedPoolInfo": "Do you already have a shortlist of candidates who you wish to assess? Add their emails here, and the assessments will be opened to them only."
  },
  "de": {
    "form": {
      "positionName": "Positionsbezeichung",
      "deadline": "Frist",
      "department": "Abteilung",
      "targetProfile": "Zielprofil",
      "targetProfileError": "Bitte wählen Sie ein Zielprofil",
      "positionTitleError": "Bitte geben Sie die Positionsbezeichnung ein",
      "targetProfileExplanation": "Damit wird angegeben, welche Rollen und Karrierewege auf Basis der Kompetenzkombinationen geeignet sein können. Denken Sie daran, dass Erfolg in einer Rolle neben Kompetenzen auch Wissen, Fähigkeiten und Motivation erfordert.",
      "jobDescription": "Positionsbeschreibung",
      "visibleToCandidate": "Wird für Kandidat:innen sichtbar sein",
      "hiringProcess": "Einstellungsprozess"
    },
    "assessmentsInfo": "Bitte wählen Sie die gewünschten Assessments aus.",
    "registeredCandidates": "Registrierte Kandidat:innen",
    "candidateList": "Kandidat:innen-Liste",
    "inviteNewCandidate": "Neuen Kandidat:innen einladen",
    "viewPoolCandidates": "Pool-Kandidat:innen anzeigen",
    "savePool": "Pool speichern",
    "candidateCount": "{count} Kandidat:innen",
    "deleteConfirmTitle": "Bitte bestätigen Sie, dass Sie diesen Pool {title} löschen möchten",
    "deleteConfirmCannotUndo": "Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirmData": "Alle Daten zu diesem Pool werden dauerhaft gelöscht.",
    "deleteConfirmTalentAccess": "Kandidat:innen können weiterhin auf ihre eigenen Daten auf der Talent-Plattform zugreifen.",
    "toasts": {
      "updated": "Pool erfolgreich aktualisiert",
      "updateError": "Änderungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
      "networkError": "Netzwerkfehler. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
      "deleted": "Pool erfolgreich gelöscht",
      "deleteError": "Pool konnte nicht gelöscht werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
      "deleteSystemError": "Systemfehler beim Löschen des Pools. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
      "deleteUnexpected": "Beim Löschen des Pools ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
      "inviteResent": "Einladung erneut gesendet.",
      "inviteResendError": "Einladung konnte nicht gesendet werden, versuchen Sie es später erneut"
    },
    "closedPoolInfo": "Haben Sie bereits eine Shortlist von Kandidat:innen, die Sie bewerten möchten? Fügen Sie hier ihre E-Mails hinzu, und die Assessments werden nur für sie geöffnet."
  },
  "fi": {
    "form": {
      "positionName": "Tehtävän nimi",
      "deadline": "Määräaika",
      "department": "Osasto",
      "targetProfile": "Kohdeprofiili",
      "targetProfileError": "Valitse kohdeprofiili",
      "positionTitleError": "Anna tehtävänimike",
      "targetProfileExplanation": "Tämä kertoo, mitkä roolit ja urapolut voisivat sopia tälle henkilölle osaamisyhdistelmien perusteella. Muista, että roolissa menestyminen edellyttää osaamisen lisäksi myös tietoja, taitoja ja motivaatiota.",
      "jobDescription": "Kuvaus",
      "visibleToCandidate": "Näkyy hakijoille",
      "hiringProcess": "Rekrytointiprosessi"
    },
    "assessmentsInfo": "Valitse hakijoille arvioinnit.",
    "registeredCandidates": "Rekisteröidyt hakijat",
    "candidateList": "Hakijalista",
    "inviteNewCandidate": "Kutsu uusi hakija",
    "viewPoolCandidates": "Näytä poolin hakijat",
    "savePool": "Tallenna pooli",
    "candidateCount": "{count} hakijaa",
    "deleteConfirmTitle": "Vahvista, että haluat poistaa poolin {title}",
    "deleteConfirmCannotUndo": "Tätä toimintoa ei voi kumota.",
    "deleteConfirmData": "Kaikki tähän pooliin liittyvät tiedot poistetaan pysyvästi.",
    "deleteConfirmTalentAccess": "Hakijat voivat kuitenkin yhä käyttää omia tietojaan Talent-alustalla.",
    "toasts": {
      "updated": "Pooli päivitetty",
      "updateError": "Muutosten tallentaminen epäonnistui. Yritä uudelleen tai ota yhteyttä tukeen.",
      "networkError": "Verkkovirhe. Yritä uudelleen tai ota yhteyttä tukeen.",
      "deleted": "Pooli poistettu",
      "deleteError": "Poolia ei voitu poistaa. Yritä uudelleen tai ota yhteyttä tukeen.",
      "deleteSystemError": "Järjestelmävirhe poolia poistettaessa. Yritä uudelleen tai ota yhteyttä tukeen.",
      "deleteUnexpected": "Poolia poistettaessa tapahtui odottamaton virhe. Yritä uudelleen tai ota yhteyttä tukeen.",
      "inviteResent": "Kutsu lähetetty uudelleen.",
      "inviteResendError": "Kutsun lähettäminen ei onnistunut. Yritä myöhemmin uudelleen"
    },
    "closedPoolInfo": "Onko sinulla jo valmiiksi rajattu joukko hakijoita, jotka haluat arvioida? Lisää heidän sähköpostiosoitteensa tähän, niin arvioinnit avataan vain heille."
  }
};

export default dictionary;
